import { API } from "../instances"

export const validateEmail = async (parameter) => {
    const response = await API().get(`core/parameter/${parameter}`)
    return response.data.data
}